/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "93fb2cb6e0dd7e1807cda337f045c7e8eadfd071";
